/**
 * Medbook
 * Medbook api
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserTrainingPlanCourseTypesInnerSettingsStatusses } from './userTrainingPlanCourseTypesInnerSettingsStatusses';
import { TrainingCourseTypeSettingsDateEnum } from './trainingCourseTypeSettingsDateEnum';


/**
 * 
 */
export interface UserTrainingPlanCourseTypesInnerSettings { 
    /**
     * 
     */
    isExemption?: boolean;
    /**
     * 
     */
    location?: UserTrainingPlanCourseTypesInnerSettings.LocationEnum;
    date?: TrainingCourseTypeSettingsDateEnum;
    /**
     * 
     */
    hasDomains?: boolean;
    /**
     * 
     */
    hasClass?: boolean;
    /**
     * 
     */
    domainRequired?: boolean;
    /**
     * 
     */
    domainSingle?: boolean;
    /**
     * 
     */
    hidePublicEpa?: boolean;
    /**
     * 
     */
    hasHourRegistrations?: boolean;
    /**
     * 
     */
    hourRegistrationType?: UserTrainingPlanCourseTypesInnerSettings.HourRegistrationTypeEnum;
    /**
     * 
     */
    hourRegistrationValidation?: boolean;
    /**
     * 
     */
    hourRegistrationValidationCredentials?: Array<string>;
    /**
     * 
     */
    hourRegistrationCourseTypeId?: number;
    /**
     * 
     */
    hourRegistrationDomains?: boolean;
    /**
     * 
     */
    hourRegistrationWeekend?: boolean;
    /**
     * 
     */
    hourRegistrationCountOvertime?: boolean;
    /**
     * 
     */
    canhaveMultipleOccurrences?: boolean;
    statusses?: UserTrainingPlanCourseTypesInnerSettingsStatusses;
    /**
     * 
     */
    consent?: boolean;
    /**
     * 
     */
    epa?: boolean;
    /**
     * 
     */
    consentDu?: string;
    /**
     * 
     */
    consentNl?: string;
    /**
     * 
     */
    consentFr?: string;
    /**
     * 
     */
    consentEn?: string;
    /**
     * 
     */
    info?: boolean;
    /**
     * 
     */
    infoDu?: string;
    /**
     * 
     */
    infoNl?: string;
    /**
     * 
     */
    infoFr?: string;
    /**
     * 
     */
    infoEn?: string;
}
export namespace UserTrainingPlanCourseTypesInnerSettings {
    export type LocationEnum = 'database' | 'custom';
    export const LocationEnum = {
        Database: 'database' as LocationEnum,
        Custom: 'custom' as LocationEnum
    };
    export type HourRegistrationTypeEnum = 'double' | 'single' | 'period' | 'day';
    export const HourRegistrationTypeEnum = {
        Double: 'double' as HourRegistrationTypeEnum,
        Single: 'single' as HourRegistrationTypeEnum,
        Period: 'period' as HourRegistrationTypeEnum,
        Day: 'day' as HourRegistrationTypeEnum
    };
}


